import {
    changeFontFamilyHandler,
    changeFontSizeHandler, changeTextAlignHandler,
    changeTextColor, editTextHandler, fontBoldUnderlineAndItalicHandler
} from "../productDetail/textController";
import {CheckTechniqueGradientSupport, CheckTechniqueSingleColor, handleRotation} from "./util";
import {errorMessages} from "../../assets/config.ts";
import { getCurrentProductNameAndSku } from "../../helpers/helper.ts";

export const updateHeaderProductNameAndSku = () => {
    const productNameEl = document.getElementById("headerProductName");
    const productSkuEl = document.getElementById("headerProductSku");

    const {sku, name} = getCurrentProductNameAndSku();
    productNameEl.innerHTML = name ?? '';
    productSkuEl.innerHTML = sku ?? '';
};

export function textEditorInitial() {
    changeTextColor();
    changeFontFamilyHandler();
    changeFontSizeHandler();
    handleRotation();
    fontBoldUnderlineAndItalicHandler();
    editTextHandler();
    changeTextAlignHandler();

    // To add the waring message based on the technique on load.
    const noteEL = document.getElementById('noteMessage');
    if (CheckTechniqueGradientSupport()) {
        if (!noteEL) return;
        noteEL.classList.remove('hidden')
        noteEL.innerHTML = errorMessages.NOTE_MESSAGE_TECHNIQUE;
    }
}

export function ObserveTechniqueChange() {
    const techniqueName = document.getElementById('selectedTechniqueName');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                const textColorInputbox = document.getElementById("textColor") as HTMLInputElement;
                const noteEL = document.getElementById('noteMessage');
                if (!noteEL.className.includes('hidden')) noteEL.classList.add('hidden')

                textColorInputbox.disabled = CheckTechniqueSingleColor();
                if (CheckTechniqueGradientSupport()) {
                    if (!noteEL) return;
                    noteEL.classList.remove('hidden')
                    noteEL.innerHTML = errorMessages.NOTE_MESSAGE_TECHNIQUE;
                }
            }
        }

    };

    const observer = new MutationObserver(callback);
    observer.observe(techniqueName, config);
}
